import React from 'react';

import { Pie } from 'react-chartjs-2';
import { useResponsive } from '../hooks/useResponsive';

export const RatioTypePieChart = ({
  firstValue,
  secondValue,
  firstLabel,
  secondLabel,
  color1,
  color2,
  title,
}) => {
  const { isMobile } = useResponsive();

  const data = {
    labels: [`${firstLabel}`, `${secondLabel} `],
    datasets: [
      {
        data: [firstValue, secondValue],
        backgroundColor: [color1, color2],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: isMobile ? true : false,
    onHover: (event, chartElement, chart) => {
      const canvas = chart.canvas;
      if (chartElement.length) {
        canvas.style.cursor = 'pointer';
      } else {
        canvas.style.cursor = 'default';
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: title,
        font: {
          size: 12,
          weight: 'bold',
        },
        color: '#000',
      },
      datalabels: {
        color: '#000',
        formatter: (value, ctx) => {
          const data = ctx.chart.data.datasets[0].data;
          const total = data.reduce((acc, val) => acc + val, 0);
          const percentage = (value / total) * 100;
          return percentage === 0 ? '' : percentage.toFixed(1) + '%';
        },
        font: {
          weight: 'bold',
        },
        anchor: 'center', // position labels in the middle of sections
        align: 'end',
      },
    },
  };

  return <Pie data={data} options={options} />;
};
